import { useCallback, useEffect, useMemo, useState } from 'react';
import { REQUEST_STATUSES } from 'consts';
import { collectError } from 'utils';

import { createDefaultMeta, getAppType } from '../../utils';
import { fetchMeta } from '../../../../api/fx';
import type { MetaState } from '../../constants';
import { metaContext } from '../../constants';

interface MetaProviderProps {
    children: React.ReactNode;
}

const MetaProvider: React.FC<MetaProviderProps> = ({ children }) => {
    const [meta, setMeta] = useState<MetaState>(createDefaultMeta(getAppType()));

    const updateMeta = useCallback((appType: MetaState['appType']) => {
        setMeta(state => ({ ...state, appType }));
    }, []);

    const providerValue = useMemo(() => ({ data: meta, updateMeta }), [updateMeta, meta]);

    useEffect(() => {
        void (async () => {
            try {
                setMeta(state => ({ ...state, status: REQUEST_STATUSES.PENDING })); // NOSONAR
                const response = await fetchMeta(meta.appType);
                setMeta(state => ({ ...state, meta: response.payload, status: REQUEST_STATUSES.SUCCESS })); // NOSONAR
            } catch (error: unknown) {
                setMeta({ ...createDefaultMeta(getAppType())(), status: REQUEST_STATUSES.ERROR });
                collectError(error);
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <metaContext.Provider value={providerValue}>{children}</metaContext.Provider>;
};

export default MetaProvider;
